/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SparkJob } from '../models/SparkJob';

export class ListSparkJobsResponse {
  /**
  * List of Spark jobs
  */
  'sparkJobs': Array<SparkJob>;
  /**
  * Token to retrieve the next page of results
  */
  'nextToken'?: string | null;
  /**
  * Total number of Spark jobs matching the filter
  */
  'totalCount'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sparkJobs",
      "baseName": "sparkJobs",
      "type": "Array<SparkJob>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSparkJobsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

